"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlloy = void 0;
const react_1 = require("react");
const AlloyManager_1 = require("./AlloyManager");
const POLL_INTERVAL = 100;
const MAX_WAIT_MS = 5000;
function useAlloy() {
    const [alloy, setAlloy] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let mounted = true;
        let attempts = 0;
        let timeoutId = null;
        const maxAttempts = Math.ceil(MAX_WAIT_MS / POLL_INTERVAL);
        const check = () => {
            const instance = AlloyManager_1.AlloyManager.getInstance();
            if (instance && mounted) {
                setAlloy(() => instance);
                return;
            }
            attempts++;
            if (attempts < maxAttempts) {
                timeoutId = setTimeout(check, POLL_INTERVAL);
            }
        };
        check();
        return () => {
            mounted = false;
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, []);
    return alloy;
}
exports.useAlloy = useAlloy;
